import TitleComponent from "@/components/shared/TitleComponent";

export default function AdminDiscoverTable() {
  return <TitleComponent title="Admin Discover Table" />;
}
